import React from 'react';
import LayeredScrubSvg from './LayeredScrubSvg';
import LayeredTunicSvg from './LayeredTunicSvg';

export const SCRUB_TEMPLATE_ID = 'scrub-vneck-v1';
export const TUNIC_TEMPLATE_ID = 'healthcare-tunic-v1';

export default function ConfigurableUniformSvg({ templateId = SCRUB_TEMPLATE_ID, ...props }) {
  if (templateId === TUNIC_TEMPLATE_ID) return <LayeredTunicSvg {...props} />;
  return <LayeredScrubSvg {...props} />;
}
